import { Component, Input, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { constantUrl } from "src/app/Shared/constantUrl";
import { QuickLoanService } from "../../../_QuickLoan/services/quickLoan.service";

@Component({
    selector: "app-asset-subcard-info",
    templateUrl: "./asset-subcard-info.component.html",
    styleUrls: ["./asset-subcard-info.component.scss"],
    standalone: false
})
export class AssetSubcardInfoComponent implements OnInit {
  @Input() assetData: any;
  @Input() AssetsAttachment: any;
  @Input() ApplicationNumber: any;
  @Input() GoldAssets: any;
  @Input() LegalAssets: any;
  @Input() ValuationAssestsDetails: any;
  @Input() ValuationAttachments: any;
  displayedAssetItemColumns: any;
  displayedLegalAssetColumns: any;
  displayedValuationAssetColumns: any;
  assetTotal: any;
  jsonDataForGold: any;
  fixrate24ct: any = 100 / 24;
  docBaseUrl: any = constantUrl.CrcApplicationDocUrl;
  dataLegalSource: any;
  legalAssetsDataSource: any;
  valuationAssetsDataSource: any;
  applicationDocUrl: any = constantUrl.CrcApplicationDocUrl;
  valuationProcessCards: any[] = [];
  legalProcessCards: any[] = [];

  constructor(private _QuickLoanService: QuickLoanService) {}

  ngOnInit(): void {
    this.jsonDataForGold = new MatTableDataSource(this.GoldAssets);
    const legalRows = (this.LegalAssets || []).filter(
      (x: any) => x.Process_Type === "Legal"
    );
    const valuationRows = (this.LegalAssets || []).filter(
      (x: any) => x.Process_Type === "Valuation"
    );
    this.legalAssetsDataSource = new MatTableDataSource(legalRows);
    this.valuationAssetsDataSource = new MatTableDataSource(valuationRows);
    this.setProcessCards();

    this.getAssetTotal();
    this.displayedLegalAssetColumns = [
      "Id",
      "Process_VendorName",
      "ProcessDone_on",
      "Attachment1",
      "Attachment2",
      "Process_Remark",
    ];
    this.displayedValuationAssetColumns = [
      "Id",
      "Process_VendorName",
      "Valuation_Type",
      "Valuation_Amount",
      "Valuation_Type2",
      "Valuation_Amount2",
      "ProcessDone_on",
      "Attachment1",
      "Attachment2",
      "Process_Remark",
    ];
    this.displayedAssetItemColumns = [
      "Id",
      "ItemName",
      "ItemType",
      "Qty",
      "PurityCT",
      "GrossWt",
      "StoneWt",
      "OtherWt",
      "NetWt",
      "PureWt",
      "ValulationRate_PerCT",
    ];
  }

  getAssetTotal() {
    if (this.jsonDataForGold?.filteredData[0]?.length == 0) {
      this.assetTotal = undefined;
    } else {
      this.assetTotal = {
        Qty: 0,
        GrossWt: 0,
        StoneWt: 0,
        OtherWt: 0,
        NetWt: 0,
        TotalAmount: 0,
      };
      this.jsonDataForGold?.filteredData?.forEach((obj: any) => {
        this.assetTotal.Qty = Number(this.assetTotal.Qty) + Number(obj.Qty);
        this.assetTotal.GrossWt =
          Number(this.assetTotal.GrossWt) + Number(obj.GrossWt);
        this.assetTotal.StoneWt =
          Number(this.assetTotal.StoneWt) + Number(obj.StoneWt);
        this.assetTotal.NetWt =
          Number(this.assetTotal.NetWt) + Number(obj.NetWt);
        this.assetTotal.TotalAmount =
          Number(this.assetTotal.TotalAmount) + Number(obj.ValulationAmount);
      });
      // this.assetModel.TotalValulationAmount = this.assetTotal.TotalAmount;
    }
  }

  //  mapping Item28 attachments to the matching Item27 record by Id.
  setProcessCards() {
    const allAttachments = Array.isArray(this.ValuationAttachments)
      ? this.ValuationAttachments
      : [];
    //  prefer the combined process array when available so valuation cards do not duplicate.
    const processSource =
      Array.isArray(this.LegalAssets) && this.LegalAssets.length > 0
        ? this.LegalAssets
        : this.ValuationAssestsDetails || [];
    const valuationRows = processSource.filter(
      (x: any) => x.Process_Type === "Valuation"
    );
    const legalRows = processSource.filter(
      (x: any) => x.Process_Type === "Legal"
    );

    const mapWithAttachments = (records: any[]) =>
      (records || []).map((record: any) => ({
        ...record,
        attachments: allAttachments.filter(
          (attachment: any) => Number(attachment?.Id) === Number(record?.Id)
        ),
      }));

    this.valuationProcessCards = mapWithAttachments(valuationRows);
    this.legalProcessCards = mapWithAttachments(legalRows);
  }
}
